import { render } from "./AssemblyProductionSchedulingRecord.vue?vue&type=template&id=3becd216&scoped=true"
import script from "./AssemblyProductionSchedulingRecord.vue?vue&type=script&lang=js"
export * from "./AssemblyProductionSchedulingRecord.vue?vue&type=script&lang=js"

import "./AssemblyProductionSchedulingRecord.vue?vue&type=style&index=0&id=3becd216&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3becd216"]])

export default __exports__